import { mapActions } from "vuex";
import types from "../store/types";

export default {
  methods: {
    ...mapActions([types.actions.logout]),
    onClickLogout: function () {
      this[types.actions.logout]().then(() => {
        window.onbeforeunload = null;
        this.$router.go("/");
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/logout.js